<template>
  <footer>
    <div>      
      <div>
        <h2>Location</h2>
        <div class='schedule'>
          <p v-html="$store.state.address"/>
        </div>
      </div>
      <div>
        <h2>Appointment Hours</h2>
        <div class='schedule'>
          <p>{{ $store.state.days }} {{ $store.state.hours }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
.schedule {
  margin:15px 0;
  text-transform: uppercase;
  p {
    color:var(--white);
  }
}
footer {
  font-size: 1rem;
  text-align: center;
  color: var(--white);
  background-color:var(--green);
  background-image:url('~@/assets/images/footer.jpg');
  background-size: cover;
  padding: 45px 0;
  font-family: 'Alternate Gothic No3 D';
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1000px;
    margin: 0 auto;
    flex-direction: column;
    gap: 20px;            
    @media (min-width:400px) {
      align-items: flex-start;
      flex-direction: row;      
      justify-content: space-between;
      max-width: 500px;
      margin:0 auto;
      gap:65px;
      text-align: left;
    }
  }  
  h2 {
    font-size: 1rem;
    margin: 0;
    margin-bottom:7px;
    text-transform: uppercase;    
  }
  p {
    margin: 0;
    color:var(--white);
  }
}
a {
  text-decoration: none;
  color:inherit;
}
</style>